import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class Columns {

  static async load(id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/column/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          container: id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async add(container, column_name){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/column/",
        method: "POST",
        data: {
          _console_token: UserSession.token,
          container: container,
          name: column_name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async edit(column_id, column_name){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/column/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: column_id,
          name: column_name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async delete(column_id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/column/",
        method: "DELETE",
        data: {
          _console_token: UserSession.token,
          id: column_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }
}
